<div *ngIf="show" class="frame slide-right-on-hover" (click)="onBannerClick()">
  <img *ngIf="type === AboBannerType.Subscription" class="abo-logo" src="/assets/images/abo/abo-logo.png" alt="abo logo">
  <div  *ngIf="type === AboBannerType.Camera" class="camera-logo">
    <mat-icon>live_tv</mat-icon>
  </div>
  <div class="text-container">
    <span id="title">{{title}}</span>
    <span>{{subtitle}}</span>
  </div>
  <div class="arrow">
    <mat-icon>arrow_forward</mat-icon>
  </div>
</div>
